<template>
  <admin-only redirectOnNotAuthorized>
    <v-container fluid>
      <v-toolbar color="white">
        <h2 class="headline ml-5"> <v-icon>mdi-brightness-percent</v-icon> Lohnarten</h2>
      </v-toolbar>
      <br />
      <v-card>
        <v-card-title>
          <v-btn
              color="success"
              rounded
              large
              @click="addExtraCharge()"
          >
            <v-icon>mdi-brightness-percent</v-icon>
            Lohnart hinzufügen
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
            <tr>
              <th class="text-left">Lohnart</th>
              <th class="text-left">Bezeichnung</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(e, i) in extraCharges" :key="e.id" @click="selectExtraCharge(i)">
              <td>{{e.name}}</td>
              <td>{{ e.code }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="showExtraChargeModal" :persistent="true" max-width="600px">
      <extra-charge
        v-if="showExtraChargeModal"
        :initialData="selectedExtraCharge"
        @confirm="onExtraChargeAddOrUpdateConfirm"
        @cancel="cancelExtraChargeAddOrUpdate"
        @delete="deleteSelectedExtraCharge"
      />
    </v-dialog>
  </admin-only>
</template>

<script>
import { mapState } from "vuex";
import timeparkApi from '../timeparkApi';
import ExtraCharge from './extraCharges/ExtraCharge';

export default {
  name: 'Lohnarten',
  components: {
    ExtraCharge,
  },
  computed: {
    ...mapState(['extraCharges']),
  },
  methods: {
    selectExtraCharge(i) {
      this.selectedExtraCharge = this.extraCharges[i];
      this.showExtraChargeModal = true;
    },
    addExtraCharge() {
      this.showExtraChargeModal = true;
    },
    onExtraChargeAddOrUpdateConfirm(extraCharge) {
      this.showExtraChargeModal = false;
      this.selectedExtraCharge = null;

      if (extraCharge.id) {
        timeparkApi
          .editExtraCharge(extraCharge)
          .then(response => {
            this.$store.commit('setExtraCharges', response.data);
          });
      } else {
        timeparkApi
          .createExtraCharge(extraCharge)
          .then(response => {
            this.$store.commit('setExtraCharges', response.data);
          });
      }
    },
    cancelExtraChargeAddOrUpdate() {
      this.showExtraChargeModal = false;
      this.selectedExtraCharge = null;
    },
    deleteSelectedExtraCharge() {
      this.showExtraChargeModal = false;

      timeparkApi
        .deleteExtraCharge(this.selectedExtraCharge.id)
        .then(r => {
          this.$store.commit('setExtraCharges', r.data);
          this.selectedExtraCharge = null;
        });
    },

  },
  data: () => ({
    showExtraChargeModal: false,
    selectedExtraCharge: null,
  }),
};
</script>
